import React from 'react'
import { FormattedMessage } from 'react-intl'

const LeadIntakeVendorItem = ({ vendor }: { vendor: any}) => {
  return (
        <div className='vendor_item'>
            <img
                className='vendor_img'
                alt='Typography'
                src={vendor.thumbnail_url}/>
            <div className='vendor_content w-100'>
                <div className="d-flex align-items-center">
                    <img
                        className='vendor_logo'
                        alt='CakeLogo'
                        src={vendor.image_url}/>
                    <div className='ml-2'>
                        <h6>{vendor.name}</h6>
                    </div>
                </div>
                <div className="contacts mt-4 mb-2">
                    <FormattedMessage id='guests.contact' tagName="h6" />
                    <div className="d-flex gap-3">
                        <FormattedMessage id='guests.phone'>
                            {text => <h6 className='field'>{text}</h6>}
                        </FormattedMessage>
                        <p>+{vendor.phone}</p>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default LeadIntakeVendorItem
